
<ng-select [items]="dataList" [bindLabel]="keyword" [placeholder]="placeHolderName" (change)="onValueSelect()"
    bindValue="id" [(ngModel)]="selectedid" [clearable]="false">
</ng-select>
